<app-userapi-shared-oauth [userApi]="userApi()">
  <p [innerHTML]="userApi().api.configDescription"></p>
</app-userapi-shared-oauth>
